import { useRootStore } from '~/store/root'
import { useExperimentsStore } from '~/store/experiments'

export default defineNuxtRouteMiddleware(async (to, from) => {
    const rootStore = useRootStore()
    const experimentsStore = useExperimentsStore()

    // Skip setting anonymousUserExperiments if the user is logged in, has an authUser,
    // if anonymous experiments are already loaded, or if the user agent is a test user
    if (
      rootStore.authUser ||
      rootStore.isLoggedIn ||
      experimentsStore.loadedAnonymousExperiments
    ) {
      return
    }

    // Skip if the user agent is a test user
    // This is to prevent anonymous experiments from being set for e2e testing
    if (isLendioTestUser()) {
      return
    }

    // Setup anonymous experiments
    const { experimentTestIds, experimentTestId } = to.query || {}
    const evalStringIds = Array.isArray(experimentTestIds) ? experimentTestIds.join(',') : experimentTestIds ? experimentTestIds : ''
    const evalStringId = Array.isArray(experimentTestId) ? experimentTestId.join(',') : experimentTestId ? experimentTestId : ''
    const testIds = [evalStringIds, evalStringId].filter(str => str && str.trim() !== '').join(',').trim().split(',')

    await experimentsStore.getAnonymousExperiments(testIds)
})
